import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
export function TermsPage() {
  return <div className="min-h-screen bg-gray-900 text-white font-sans" data-id="element-3699">
      {/* Header */}
      <header className="bg-black border-b border-gray-800 py-4 px-4" data-id="element-3700">
        <div className="max-w-4xl mx-auto flex items-center gap-4" data-id="element-3701">
          <Link to="/meta-martes" className="flex items-center gap-2 text-gray-400 hover:text-white transition-colors" data-id="element-3702">
            <ArrowLeft className="w-5 h-5" data-id="element-3703" />
            <span className="text-sm" data-id="element-3704">Volver</span>
          </Link>
        </div>
      </header>

      {/* Main Content */}
      <main className="max-w-4xl mx-auto px-4 py-8 md:py-12" data-id="element-3705">
        <h1 className="text-3xl md:text-4xl font-bold mb-8 text-white" data-id="element-3706">
          Términos y Condiciones
        </h1>

        <div className="text-gray-300 text-sm md:text-base space-y-6 leading-relaxed" data-id="element-3707">
          <p data-id="element-3708">
            Al registrarte y participar en el 48 Hrs AI Cash Machine
            Masterclass, aceptas los siguientes términos y condiciones:
          </p>

          <section data-id="element-3709">
            <h2 className="text-xl font-bold text-white mt-8 mb-4" data-id="element-3710">
              1. Aceptación de Términos
            </h2>
            <p data-id="element-3711">
              Al acceder y utilizar este sitio web y registrarte para el evento,
              aceptas estar sujeto a estos términos y condiciones, todas las
              leyes y regulaciones aplicables.
            </p>
          </section>

          <section data-id="element-3712">
            <h2 className="text-xl font-bold text-white mt-8 mb-4" data-id="element-3713">
              2. Uso del Servicio
            </h2>
            <p data-id="element-3714">
              El contenido proporcionado en el masterclass es solo para fines
              educativos e informativos. No garantizamos resultados específicos
              de ingresos o éxito comercial.
            </p>
          </section>

          <section data-id="element-3715">
            <h2 className="text-xl font-bold text-white mt-8 mb-4" data-id="element-3716">
              3. Propiedad Intelectual
            </h2>
            <p data-id="element-3717">
              Todo el contenido, materiales, y recursos proporcionados son
              propiedad de 48 Hrs AI Cash Machine y están protegidos por
              derechos de autor. No está permitida la reproducción o
              distribución sin autorización expresa.
            </p>
          </section>

          <section data-id="element-3718">
            <h2 className="text-xl font-bold text-white mt-8 mb-4" data-id="element-3719">
              4. Limitación de Responsabilidad
            </h2>
            <p data-id="element-3720">
              48 Hrs AI Cash Machine no será responsable de ningún daño directo,
              indirecto, incidental o consecuente que resulte del uso o la
              imposibilidad de usar nuestros servicios.
            </p>
          </section>

          <section data-id="element-3721">
            <h2 className="text-xl font-bold text-white mt-8 mb-4" data-id="element-3722">
              5. Consentimiento para Mensajes SMS
            </h2>
            <p className="mb-4" data-id="element-3723">
              Al marcar la casilla de consentimiento SMS durante el registro,
              aceptas recibir mensajes SMS/texto recurrentes de True Marketer
              LLC al número móvil proporcionado, incluyendo:
            </p>
            <ul className="list-disc list-inside space-y-2 ml-4" data-id="element-3724">
              <li data-id="element-3725">Actualizaciones del programa</li>
              <li data-id="element-3726">Información de capacitación</li>
              <li data-id="element-3727">Mensajes de marketing/promocionales</li>
            </ul>
            <p className="mt-4" data-id="element-3728">
              Estos mensajes son enviados mediante un sistema de marcación
              telefónica automática/tecnología automatizada. La frecuencia de
              los mensajes varía. Pueden aplicar tarifas de mensajes y datos.
            </p>
            <p className="mt-4" data-id="element-3729">
              <strong className="text-white" data-id="element-3730">Cancelación:</strong> Responde STOP
              para cancelar.
            </p>
            <p className="mt-2" data-id="element-3731">
              <strong className="text-white" data-id="element-3732">Ayuda:</strong> Responde HELP para
              ayuda.
            </p>
            <p className="mt-4" data-id="element-3733">
              El consentimiento no es una condición de compra.
            </p>
          </section>

          <section data-id="element-3734">
            <h2 className="text-xl font-bold text-white mt-8 mb-4" data-id="element-3735">
              6. Modificaciones
            </h2>
            <p data-id="element-3736">
              Nos reservamos el derecho de modificar estos términos en cualquier
              momento. El uso continuado del servicio después de cambios
              constituye la aceptación de los nuevos términos.
            </p>
          </section>

          <section data-id="element-3737">
            <h2 className="text-xl font-bold text-white mt-8 mb-4" data-id="element-3738">
              7. Garantía y Reembolsos
            </h2>
            <p data-id="element-3739">
              Para productos de pago, ofrecemos una garantía de satisfacción de
              30 días. Si no estás satisfecho con el producto, puedes solicitar
              un reembolso completo dentro de los primeros 30 días de la compra.
            </p>
          </section>

          <section data-id="element-3740">
            <h2 className="text-xl font-bold text-white mt-8 mb-4" data-id="element-3741">
              8. Descargo de Responsabilidad sobre Resultados
            </h2>
            <p className="mb-4" data-id="element-3742">
              48Hrs AI CASH MACHINE y todo el equipo asociado no asume
              responsabilidad por los resultados, ingresos o éxito que puedas
              obtener, ni garantiza resultados específicos.
            </p>
            <p className="mb-4" data-id="element-3743">
              El éxito depende en parte del tiempo que dediques y de tu
              implementación de las guías, estrategias y soporte proporcionados.
            </p>
            <p className="mb-4" data-id="element-3744">
              Todo el contenido, entrenamientos, artículos y material educativo
              tiene fines formativos únicamente y no debe interpretarse como
              asesoría financiera, legal o de inversión.
            </p>
            <p data-id="element-3745">
              Los testimonios compartidos corresponden a experiencias reales de
              usuarios, pero no deben considerarse como resultados típicos.
            </p>
          </section>

          <section data-id="element-3746">
            <h2 className="text-xl font-bold text-white mt-8 mb-4" data-id="element-3747">
              9. Afiliaciones
            </h2>
            <p data-id="element-3748">
              Este sitio no forma parte de Google, Google Inc., Facebook/Meta o
              Meta Inc. Además, este sitio no está avalado, patrocinado ni
              aprobado por Google ni Meta de ninguna manera.
            </p>
          </section>

          <section data-id="element-3749">
            <h2 className="text-xl font-bold text-white mt-8 mb-4" data-id="element-3750">Contacto</h2>
            <p data-id="element-3751">
              Para preguntas sobre estos términos, contacta:{' '}
              <a href="mailto:support@truemarketer.com" className="text-[#00f7fc] hover:text-[#00d7dc] underline" data-id="element-3752">
                support@truemarketer.com
              </a>
            </p>
          </section>

          <section className="mt-12 pt-8 border-t border-gray-700" data-id="element-3753">
            <p className="text-gray-500 text-sm" data-id="element-3754">
              Última actualización: Febrero 2025
            </p>
          </section>
        </div>
      </main>

      {/* Footer */}
      <footer className="bg-black border-t border-gray-800 py-6 px-4" data-id="element-3755">
        <div className="max-w-4xl mx-auto text-center" data-id="element-3756">
          <p className="text-gray-600 text-xs mb-2" data-id="element-3757">
            &copy; 2025 48 Hrs AI Cash Machine. Todos los derechos reservados.
          </p>
          <p className="text-gray-500 text-xs" data-id="element-3758">
            Soporte:{' '}
            <a href="mailto:support@truemarketer.com" className="text-[#00f7fc] hover:text-[#00d7dc] transition-colors" data-id="element-3759">
              support@truemarketer.com
            </a>
          </p>
          <div className="flex items-center justify-center gap-4 text-xs mt-2" data-id="element-3760">
            <span className="text-white" data-id="element-3761">Términos</span>
            <span className="text-gray-600" data-id="element-3762">|</span>
            <Link to="/privacy" className="text-gray-500 hover:text-white transition-colors underline" data-id="element-3763">
              Privacidad
            </Link>
          </div>
        </div>
      </footer>
    </div>;
}